import { TenantState, tenantInitialState } from "./tenant.state";
import { TenantActions, TenantActionTypes } from "./tenant.actions";

export function tenantReducer(state: TenantState = tenantInitialState, action: TenantActions): TenantState {
  switch (action.type) {
    case TenantActionTypes.LOAD_TENANT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case TenantActionTypes.LOAD_TENANT_SUCCESS:
      return {
        ...state,
        tenant: action.payload,
        loading: false,
        error: null
      };

    case TenantActionTypes.LOAD_TENANT_FAILURE:
      return {
        ...state,
        tenant: null,
        loading: false,
        error: action.payload
      };

    case TenantActionTypes.CLEAR_TENANT_ERROR:
      return {
        ...state,
        error: null
      };

    default:
      return state;
  }
} 